export default __webpack_public_path__ + "static/media/3.120e100e.jpg";